
/// <amd-module name="TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Components/DisabledSSHPublicKeysView" />
import React = require("react");

import * as Resources from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { ZeroData } from "VSSUI/ZeroData";
import { getAssetLocation } from "VSS/Platform/Location";

export default class DisabledSSHPublicKeysView extends VssComponent<{}> {
    public render() {
        return (
            <Card className="ssh-public-keys-zero-card-content" contentProps={{ contentPadding: false }}>
                <ZeroData
                    className="ssh-key-zero-data"
                    imagePath={getAssetLocation(this.context.pageContext,
                        "ms.vss-tfs-web/platform-content/Illustrations/general-no-results-found.svg")}
                    imageAltText={Resources.SSHPublicKeysDisabledTitle}
                    primaryText={Resources.SSHPublicKeysDisabledTitle}
                    secondaryText={Resources.SSHPublicKeysDisabledMessage}
                />
            </Card>
        );
    }
}
